export type MacroPointStartTrackingStatus = 'STARTED' | 'NEEDS_INFO' | 'ERROR';

export class MacroPointStartTrackingResponse {
  status?: MacroPointStartTrackingStatus;
  requiredReferenceNumbers?: string[];
  error?: string;

  constructor(opts?: Partial<MacroPointStartTrackingResponse>) {
    if (opts?.status != null) {
      this.status = opts.status;
    }
    if (opts?.requiredReferenceNumbers != null) {
      this.requiredReferenceNumbers = opts.requiredReferenceNumbers;
    }
    if (opts?.error != null) {
      this.error = opts.error;
    }
  }
}
